module.exports = __webpack_public_path__ + "img/blockS2-card2.309c8176.svg";